module.exports = __webpack_public_path__ + "static/media/img_39.75c9b302.png";